import { render, staticRenderFns } from "./ExportacaoGridParaExcel.vue?vue&type=template&id=02137f34&scoped=true"
import script from "./ExportacaoGridParaExcel.vue?vue&type=script&lang=js"
export * from "./ExportacaoGridParaExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02137f34",
  null
  
)

export default component.exports